'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);


var _constants = require('./constants');


var _components = require('../../../components');


var _ModalError = require('./ModalError.scss');var styles = _interopRequireWildcard(_ModalError);


var _constants2 = require('../../../constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Styles
// Helpers
var ModalError = function ModalError(_ref)





{var isOpen = _ref.isOpen,onRequestClose = _ref.onRequestClose,translate = _ref.translate,error = _ref.error,isRtl = _ref.isRtl;
  var errorLabels = (0, _constants.getErrorKeyCase)(error && error.details && error.details.errorKey);
  var title = errorLabels.title;
  var subTitle = errorLabels.subTitle;

  var isCodeError = error && error.status === 400 && error.message && error.message.includes('[code]');
  if (isCodeError) {
    title = 'code_validation_error';
  }

  if (error && error.status === 401 && error.message) {
    switch (error.message) {
      case 'No user with this email':{
          title = 'no_user_with_this_email';
          break;
        }
      case 'No user with this phone':{
          title = 'no_user_with_this_phone';
          break;
        }
      case 'Wrong password':{
          title = 'wrong_password';
          break;
        }
      default:{
          break;
        }}

  }

  var shouldAskSupport = title === 'cannot_send_sms_at_this_moment';

  return (
    _react2.default.createElement(_components.Modal, {
        isOpen: isOpen,
        className: styles.modal,
        onRequestClose: onRequestClose,
        isRtl: isRtl },

      _react2.default.createElement('div', { className: styles.failModalContentWrapper },
        _react2.default.createElement('div', { className: styles.titleWrapper },
          _react2.default.createElement('p', { className: styles.failModalTitle }, translate('authenticationPage', 'errorKeys', title)),
          subTitle && _react2.default.createElement('p', { className: styles.failModalSubTitle }, translate('authenticationPage', 'errorKeys', subTitle))),

        shouldAskSupport &&
        _react2.default.createElement('p', { className: styles.failModalSubTitle },
          _react2.default.createElement('span', null, translate('authenticationPage', 'askAgain')),
          _react2.default.createElement('span', null,
            _react2.default.createElement('a', { href: 'mailto:' + _constants2.supportEmail }, translate('authenticationPage', 'supportLabel')))),



        _react2.default.createElement('button', {
            onClick: onRequestClose,
            className: styles.failModalButton },

          translate('authenticationPage', 'return')))));




}; // Constants
// Components
ModalError.propTypes = {
  translate: _propTypes2.default.func,
  isOpen: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  error: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool };exports.default =


ModalError;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthenticationContainer/ModalError/ModalError.js
// module id = 2924
// module chunks = 0